import { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import MaterialModal from "../components/MaterialModal";
import { deleteMaterial, listMaterialsPaged } from "../api/materials";
import { EmptyState, PageHeader, StatusBadge } from "../components/ui";

const DEFAULT_ROWS_PER_PAGE = 25;

function Materials() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
  const [total, setTotal] = useState(0);
  const [mattypeCode, setMattypeCode] = useState("");

  function reload() {
    listMaterialsPaged({
      page: page + 1,
      limit: rowsPerPage,
      mattype_code: mattypeCode || undefined,
    }).then((data) => {
      setList(data?.items || []);
      setTotal(Number(data?.total || 0));
    });
  }

  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, mattypeCode]);

  function remove(id) {
    if (!window.confirm("Silmek istiyor musun?")) return;
    deleteMaterial(id).then(() => reload());
  }

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Malzemeler"
        subtitle="Malzeme kartlarını ve varyant şablonlarını yönetin."
        actions={
          <Button
            variant="contained"
            onClick={() => {
              setSelected(null);
              setOpen(true);
            }}
          >
            + Yeni Malzeme
          </Button>
        }
      />

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel id="materials-mattype-label">Materyal Tipi</InputLabel>
          <Select
            labelId="materials-mattype-label"
            label="Materyal Tipi"
            value={mattypeCode}
            onChange={(e) => {
              setMattypeCode(e.target.value);
              setPage(0);
            }}
          >
            <MenuItem value="">Tümü</MenuItem>
            <MenuItem value="1">Hammadde</MenuItem>
            <MenuItem value="2">Yarı Mamul</MenuItem>
            <MenuItem value="3">Mamul</MenuItem>
            <MenuItem value="4">Fason</MenuItem>
            <MenuItem value="5">Sarf Malzeme</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      {!list.length ? (
        <EmptyState description="Henüz malzeme yok." actionLabel="+ Yeni Malzeme" onAction={() => setOpen(true)} />
      ) : (
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Kod</TableCell>
                <TableCell>Ad</TableCell>
                <TableCell>Tip</TableCell>
                <TableCell>Birim</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((m) => (
                <TableRow key={m.id} hover>
                  <TableCell>
                    <Typography sx={{ fontWeight: 800 }}>{m.code}</Typography>
                  </TableCell>
                  <TableCell>{m.name}</TableCell>
                  <TableCell>
                    <StatusBadge value={m.material_type || "—"} />
                  </TableCell>
                  <TableCell>{m.unit}</TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          setSelected(m);
                          setOpen(true);
                        }}
                      >
                        Düzenle
                      </Button>
                      <Button size="small" color="error" variant="outlined" onClick={() => remove(m.id)}>
                        Sil
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={(_, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setPage(0);
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            labelRowsPerPage="Sayfa başına kayıt"
          />
        </Paper>
      )}

      {open ? (
        <MaterialModal
          data={selected}
          onClose={() => setOpen(false)}
          onSaved={reload}
        />
      ) : null}

    </Stack>
  );
}

export default Materials;

